import './cards/simple-card/SimpleCardTemplate'
import './cards/youtube-card/YoutubeCardTemplate'
import './cards/html-card/HTMLCardTemplate'
import './cards/mapsindoor/MapsIndoorCardTemplate'
import './cards/canva-card/CanvaCardTemplate'
import './cards/image-card/ImageCard'
import './cards/item-list-widget/ItemList'
import './cards/map-widget/MapTemplate'

// import './cards/simple-value/SimpleValueTemplate'

import './cards/radial-gauge/RadialGaugeTemplateNew'
import './cards/donut-chart-widget/DonutChartTemplate'
import './cards/bar-line-chart-widget/BarLineChartTemplate'
import './cards/column-bar-chart-widget/ColumnBarChartTemplate'
import './cards/two-value-widget/TwoValueWidgetTemplate'
import './cards/population-percentage-widget/PopulationPercentageWidgetTemplate'
import './cards/progress-bar-percentage-widget/ProgressBarPercentageWidgetTemplate'
import './cards/multiple-value-widget/MultipleValueWidgetTemplate'
import './cards/form/Form'
import './cards/empty-widget/EmptyWidget'
import './cards/video-card/VideoCardTemplate'
import './cards/object-view/ObjectWidget'
import './cards/custom-ui-card/CustomUICard'


//temporarily until oauth flow works
// import './cards/FigmaCard/FigmaCard'
import './cards/BoxChart/BoxChart'
import './cards/statistics-card/StatisticsCardWidgetTemplate'
import './cards/image-card2/ImageCard2'
import './cards/content-card/ContentCardWidgetTemplate'
import './cards/resource-booking/ResourceBooking';
import './cards/GridLayout/GridLayoutWidgetTemplate'
import './cards/circular-percentage/CircularPercentage';
import './cards/event-list/EventList';
import './cards/CardSection/CardList';
import './cards/details-card/DetailsCard';


// mobile card templates 
import './mobile-sections/IconSectionWidget/IconSectionwidget';
import './mobile-sections/ImageCardListWidget/ImageCardListWidget';

// common 
import './common/card-list/CardListTemplate';
import './mobile-sections/ImageCardListWidget/ImageCardListWidget';
import './cards/currency-converter/CurrencyConverter'
import './common/search-widget/SearchWidget';
import './cards/heatmap-widget/HeatMapTemplate';
